<template>
  <div class="group-wrap">
    <div class="seletc-list">
      <el-select
        v-model="filterData.pkg"
        filterable
        style="width: 260px"
        placeholder="选择产品"
        @change="clickSearch()"
      >
        <el-option label="全部产品" :value="-1"> </el-option>
        <el-option
          v-for="item of appList"
          :key="item.package_name"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.package_name"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        v-model="filterData.optimizer"
        placeholder="选择优化师"
        @change="clickSearch()"
      >
        <el-option label="全部优化师" :value="-1"> </el-option>
        <el-option v-for="item of optimizerList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        v-model="filterData.adsetStatus"
        placeholder="选择广告组状态"
        @change="clickSearch()"
      >
        <el-option
          v-for="item of optionsList.filterStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        class="multiple-select"
        v-model="filterData.advertiserId"
        placeholder="全部投放账户"
        multiple
        collapse-tags
        @change="searchGropuList"
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.advertiserName + ' (' + item.company + ')'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>

      <el-select
        style="width: 160px; margin-left: 24px"
        class="multiple-select"
        v-model="filterData.campaignId"
        placeholder="选择广告计划"
        multiple
        collapse-tags
        @change="clickSearch()"
      >
        <el-option
          v-for="item of campaignIdList"
          :key="item.campaign_id"
          :label="item.campaign_name + ' (' + item.campaign_id + ')'"
          :value="item.campaign_id"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 160px; margin-left: 24px"
        v-model="filterData.deliveryPlacement"
        placeholder="选择投放位置"
        @change="clickSearch()"
      >
        <el-option label="全部投放位置" :value="-1"> </el-option>
        <el-option
          v-for="item of optionsList.placeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 24px"
        value-format="yyyyMMdd"
        :clearable="false"
        @change="clickSearch()"
      >
      </el-date-picker>
      <!-- <el-button class="submit-btn" type="primary" @click="clickSearch()"
        >提交</el-button
      > -->
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-input
          placeholder="请输入广告组名称/ID"
          prefix-icon="el-icon-search"
          v-model="filterData.adsetSearch"
          class="search-input"
          style="width: 190px"
          @input="inputSearch"
        >
        </el-input>
        <div class="mult-wrap">
          <el-button class="top-btn" style="margin-right: 16px" @click="showPlBox = true">
            <svg-icon iconClass="pl" className="pl-icon"></svg-icon>批量操作</el-button
          >
          <span class="piliang border-bg" v-show="showPlBox">
            <span class="batch-span"
              >已选择<a>{{ checkedList.length }}</a
              >账户</span
            >
            <div class="icon-list">
              <el-tooltip content="开始" placement="top">
                <svg-icon
                  iconClass="start"
                  className="batch-icon"
                  @click="editStatus(1)"
                ></svg-icon>
              </el-tooltip>
              <el-tooltip content="暂停" placement="top">
                <svg-icon iconClass="stop" className="batch-icon" @click="editStatus(2)"></svg-icon>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <i class="el-icon-delete batch-icon" @click="editStatus(3)"></i>
              </el-tooltip>
              <span class="close-icon">
                <svg-icon
                  iconClass="close"
                  className="close-btn"
                  @click="showPlBox = false"
                ></svg-icon>
              </span>
            </div>
          </span>
        </div>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :type="2"
          :platType="3"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-refresh"
          style="margin-left: 16px"
          @click="asyncData()"
          >刷新数据</el-button
        >
        <el-button
          class="top-btn"
          icon="el-icon-download"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          @selection-change="handleSelectionChange"
          :data="tableList"
          :max-height="tableMaxHeight"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="true"
          >
            <template slot-scope="scope">
              <div v-if="item.value === 'ad_name'">
                <span class="name-link" @click="checkCreative(scope.row)">{{
                  scope.row.ad_name
                }}</span>
              </div>
              <span v-else>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.value === 'budget'">
                <div>
                  {{
                    scope.row.budget_mode === "BUDGET_MODE_INFINITE"
                      ? "不限"
                      : scope.row.budget_mode === "BUDGET_MODE_DAY"
                      ? "统一预算"
                      : scope.row.budget_mode === "BUDGET_MODE_DAY_SCHEDULE"
                      ? "分日预算"
                      : "-"
                  }}
                  <i
                    class="el-icon-edit"
                    style="cursor: pointer"
                    v-if="scope.row.budget_mode"
                    @click="editBudget(scope.row)"
                  ></i>
                </div>
                <div v-if="scope.row.budget_mode === 'BUDGET_MODE_DAY_SCHEDULE'">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{ "星期一 " + scope.row.dayBudgetSchedule[0] + " CNY" }}<br />
                      {{ "星期二 " + scope.row.dayBudgetSchedule[1] + " CNY" }}<br />
                      {{ " 星期三 " + scope.row.dayBudgetSchedule[2] + " CNY" }}<br />
                      {{ "星期四 " + scope.row.dayBudgetSchedule[3] + " CNY" }}<br />
                      {{ "星期五 " + scope.row.dayBudgetSchedule[4] + " CNY" }}<br />
                      {{ "星期六 " + scope.row.dayBudgetSchedule[5] + " CNY" }}<br />
                      {{ "星期日 " + scope.row.dayBudgetSchedule[6] + " CNY" }}<br />
                    </div>
                    <div class="day_budget_wrap">
                      {{ scope.row.dayBudgetSchedule.join("、") }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else-if="scope.row.budget_mode === 'BUDGET_MODE_DAY'">
                  {{ scope.row.budget + " CNY" }}
                </div>
              </div>

              <span v-else>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isActive"
                :disabled="scope.row.putStatus === 3"
                @change="(value) => changeSingleType(scope.row, value)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>

    <!-- 预算修改弹框 -->
    <budget-modal
      ref="budgetModalRef"
      tableType="adGroup"
      @refreshData="clickSearch()"
    ></budget-modal>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import SelectField from "@/components/selectField.vue";
import BudgetModal from "../common/budgetModal.vue";
import {
  attribute,
  baseData,
  appData,
  // videoData,
} from "@/config/fieldData_kuaishou";
import {
  getDesigner,
  getAdvertiserInfo,
  queryCampaign,
  queryAdSetData_k,
  updateState,
  refreshReportData_k,
} from "@/api/promotionReport.js";
import { getCommonProductList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import { formatTableList } from "../formatData.js";
import moment from "moment";
import selectOptions from "./selectOptions.js";
export default {
  name: "GroupTable",
  components: {
    SvgIcon,
    SelectField,
    BudgetModal,
  },
  data() {
    return {
      loading: false,
      appList: [],
      optimizerList: [],
      advertiserIdList: [],
      campaignIdList: [],
      optionsList: selectOptions,
      filterData: {
        pkg: -1,
        optimizer: -1,
        adsetStatus: -1,
        advertiserId: [],
        campaignId: [],
        deliveryPlacement: -1,
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        adsetSearch: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.adGroup },
        { title: "基础数据", list: baseData },
        { title: "应用数据", list: appData },
        // { title: "视频数据", list: videoData },
      ],
      staticOptions: [{ label: "广告组名称", value: "ad_name", width: "180" }],
      tableList: [],
      tableCols: [],
      showPlBox: false,
      tableMaxHeight: window.innerHeight - 345,
      checkedList: [],
      downloadLoading: false,
    };
  },
  mounted() {
    this.initSelectOptions();
    // this.clickSearch();
  },
  methods: {
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },
    initSelectOptions() {
      getCommonProductList({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.toutiaoProductInfos;
        }
      });
      getDesigner().then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.tags;
        }
      });
      getAdvertiserInfo({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
      this.searchGropuList();
    },
    //根据账号查询广告计划
    searchGropuList(ifSearch) {
      let parmas = {
        platType: 3,
      };
      if (this.filterData.advertiserId.length > 0) {
        this.filterData.campaignId = [];
        parmas.advertiserId = this.filterData.advertiserId.join();
      }
      queryCampaign(parmas).then((res) => {
        if (res.code === "0000") {
          this.campaignIdList = res.advertiserDataDtoVos;
          //是否需要查询表格（初始化时不用查询）
          if (ifSearch) {
            this.clickSearch();
          }
        }
      });
    },
    clickSearch(filterData) {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData(filterData);
    },
    formatData() {
      let parmas = {
        page: this.pageData.page,
        size: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
        platType: 3,
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData.join());
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        let curStatus = this.optionsList.adGroupStatus.find((i) => i.value === item.data_status);
        item.data_status = curStatus ? curStatus.label : "-";
        item.isActive = item.putStatus === 1 ? true : false;
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData(filterData) {
      if (filterData) {
        //条件查询
        this.filterData.pkg = -1;
        this.filterData.optimizer = -1;
        this.filterData.adsetStatus = -1;
        this.filterData.advertiserId = [filterData.advertiser_id];
        if (filterData.campaign_id) {
          this.filterData.campaignId = [filterData.campaign_id];
        }
        this.filterData.time = filterData.time;
        this.filterData.adsetSearch = "";
      }
      let parmas = this.formatData();
      this.loading = true;
      queryAdSetData_k(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.advertiserDatas);
          this.pageData.total = res.totalCount;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "landing_type",
          "data_status",
          "create_time",
          "budget",
          "cpa_bid",
          "cost",
          "show_cnt",
          "click_cnt",
          "ctr",
          "avg_click_cost",
          "avg_show_cost",
          "convert_cnt",
          "convert_cost",
        ];
      }
      let allFieldsMap = attribute.adGroup.concat(baseData, appData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      queryAdSetData_k(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.advertiserDatas);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "广告组.xlsx", HeaderData);
        }
      });
    },
    //批量修改状态
    editStatus(status) {
      if (this.checkedList.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      } else {
        let params = {
          ad_list: this.checkedList.map((item) => {
            return {
              advertiser_id: item.advertiser_id,
              ad_id: item.ad_id,
            };
          }),
          type: 2, //广告组
          putStatus: status,
        };
        this.commitChange(params);
      }
    },
    changeSingleType(item, type) {
      let params = {
        ad_list: [
          {
            advertiser_id: item.advertiser_id,
            ad_id: item.ad_id,
          },
        ],
        type: 2, //广告组
        putStatus: type ? 1 : 2,
      };
      this.commitChange(params);
    },
    commitChange(data) {
      updateState(data).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
          this.searchData();
        }
      });
    },
    checkCreative(rowData) {
      this.$emit("checkTable", {
        name: "CreativeTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
    asyncData() {
      refreshReportData_k().then(() => {});
      this.$message({
        message: "数据同步中，预计半小时同步成功",
        type: "success",
      });
    },
    editBudget(row) {
      this.$refs.budgetModalRef.showModal(row);
    },
  },
};
</script>

<style lang="less" scoped>
.group-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .mult-wrap {
        display: flex;
        align-items: center;
        margin-right: auto;
      }
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .name-link {
        color: #1890ff;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #0285ff;
        }
      }
      .status {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 4px;
        }
        &.start::before {
          background: rgba(30, 194, 57, 1);
        }
        &.stop::before {
          background: rgba(235, 49, 49, 1);
        }
        &.delete::before {
          background: #999;
        }
      }
      .day_budget_wrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .page-wrap {
    }
  }
}
.piliang {
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 40px;
    cursor: pointer;
  }
}
</style>
